module.exports = __webpack_public_path__ + "img/num4.f508a463.jpg";